import { reportResumeDayTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_RESUME_DAY_FILTERS, RESTORE_INITIAL } = reportResumeDayTypes;

const initialState = {
  date: newDate(),
  station: null,
};

export const reportResumeDayReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_RESUME_DAY_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState

    default:
      return state;
  }
};